import { useQuery } from '@tanstack/react-query';
import { commentsApi } from '../api';
import { queryKeys } from '../queries/keys';
import type { CanvasComment } from '../types';

export interface CommentsState {
  comments: CanvasComment[];
  loading: boolean;
}

/** Canvas comments pinned on one drawing. */
export function useComments(docId: string | null | undefined): CommentsState {
  const query = useQuery({
    queryKey: queryKeys.comments(docId ?? ''),
    queryFn: () => commentsApi.list(docId!),
    enabled: Boolean(docId),
  });

  return {
    comments: query.data ?? [],
    loading: query.isPending && Boolean(docId),
  };
}
